import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';

import { QuoteBlock } from '@core/services/ai/ai-assistant.service';

@Component({
  selector: 'app-ai-quote-block',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule],
  template: `
    <figure class="q">
      <mat-icon class="q__mark">format_quote</mat-icon>
      <blockquote class="q__text">{{ block.text }}</blockquote>
      @if (block.attribution) {
        <figcaption class="q__attr">
          @if (block.icon) {
            <mat-icon class="q__icon">{{ block.icon }}</mat-icon>
          }
          <span>{{ block.attribution }}</span>
        </figcaption>
      }
    </figure>
  `,
  styles: [
    `
      :host {
        display: block;
      }
      .q {
        margin: 0;
        padding: 12px 14px 12px 16px;
        background: #fff;
        border: 1px solid rgba(15, 23, 42, 0.08);
        border-left: 3px solid #6366f1;
        border-radius: 12px;
        position: relative;
      }
      .q__mark {
        position: absolute;
        top: 8px;
        left: 12px;
        font-size: 18px;
        width: 18px;
        height: 18px;
        color: rgba(99, 102, 241, 0.4);
      }
      .q__text {
        margin: 0 0 0 26px;
        font-style: italic;
        font-size: 14px;
        line-height: 1.5;
        color: rgba(15, 23, 42, 0.85);
        overflow-wrap: anywhere;
      }
      .q__attr {
        margin: 8px 0 0 26px;
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 12px;
        color: rgba(15, 23, 42, 0.55);
        overflow-wrap: anywhere;
      }
      .q__icon {
        font-size: 14px;
        width: 14px;
        height: 14px;
        color: rgba(99, 102, 241, 0.6);
      }
    `
  ]
})
export class AiQuoteBlockComponent {
  @Input({ required: true }) block!: QuoteBlock;
}
